import React, { useState } from 'react';
import { flattenToAppURL, isInternalURL } from '@plone/volto/helpers/Url/Url';
import { withBlockExtensions } from '@plone/volto/helpers/Extensions';
import config from '@plone/volto/registry';
import ImageGalleryLightbox from './Lightbox';
import './ImageGallery.css';

const ImageGalleryView = ({ data }) => {
  const images = data.images || [];
  const columns = data.columns || 3;
  const gap = data.gap || '16px';
  const enableLightbox = data.enable_lightbox !== false; // default true
  const Image = config.getComponent({ name: 'Image' }).component;

  const [lightboxIndex, setLightboxIndex] = useState(null);

  if (images.length === 0) return null;

  const handleOpen = (idx) => (evt) => {
    if (!enableLightbox) return;
    evt.preventDefault();
    setLightboxIndex(idx);
  };

  return (
    <>
      <div
        className={
          enableLightbox
            ? 'block image-gallery lightbox-enabled'
            : 'block image-gallery'
        }
        style={{
          display: 'grid',
          gridTemplateColumns: `repeat(${columns}, 1fr)`,
          gap,
        }}
      >
        {images.map((img, idx) => (
          <figure
            key={idx}
            className="image-gallery-item"
            onClick={enableLightbox ? handleOpen(idx) : undefined}
            onKeyDown={
              enableLightbox
                ? (evt) => {
                    if (evt.key === 'Enter' || evt.key === ' ') {
                      evt.preventDefault();
                      setLightboxIndex(idx);
                    }
                  }
                : undefined
            }
            tabIndex={enableLightbox ? 0 : undefined}
            role={enableLightbox ? 'button' : undefined}
            aria-label={enableLightbox ? `Open image ${idx + 1}` : undefined}
          >
            {img.image_scales ? (
              <Image
                item={{
                  '@id': img.url,
                  image_field: img.image_field,
                  image_scales: img.image_scales,
                }}
                alt={img.alt || ''}
                loading="lazy"
                responsive={true}
              />
            ) : img.url ? (
              <img
                src={
                  isInternalURL(img.url)
                    ? `${flattenToAppURL(img.url)}/@@images/image/large`
                    : img.url
                }
                alt={img.alt || ''}
                loading="lazy"
              />
            ) : null}
            {img.caption && (
              <figcaption className="image-gallery-caption">
                {img.caption}
              </figcaption>
            )}
          </figure>
        ))}
      </div>
      {enableLightbox && lightboxIndex !== null && (
        <ImageGalleryLightbox
          images={images}
          index={lightboxIndex}
          onClose={() => setLightboxIndex(null)}
          zoom={data.lightbox_zoom !== false}
          fullscreen={data.lightbox_fullscreen !== false}
          counter={data.lightbox_counter !== false}
        />
      )}
    </>
  );
};

export default withBlockExtensions(ImageGalleryView);
